
import React from 'react';
import PropTypes from 'prop-types';
// @ts-ignore
import { Banner } from '@pwc/appkit-react/lib/Banner';
import { renderDateWithFormat, dateFormatWithoutTime } from '@client-shared/dateHelpers';

const ExpirationBannerComponent = ({ expirationDate, isAboutToExpire }:
  { expirationDate: string, isAboutToExpire: boolean }) => {
  if (!isAboutToExpire) {
    return null;
  }

  const warningExpirationMessage = (
    <>
      Your user is set to expire on <b>{renderDateWithFormat(expirationDate, dateFormatWithoutTime)}</b>.
      Please contact your client implementation lead to verify your expiration date will be extended prior that date.
    </>
  );

  return (
    <div className="expiration-date-banner">
      <Banner status="warning" content={warningExpirationMessage} />
    </div>
  );
};

ExpirationBannerComponent.propTypes = {
  expirationDate: PropTypes.string,
  isAboutToExpire: PropTypes.bool,
};

export default ExpirationBannerComponent;
